import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await fetch('https://server.multisellerpro.com/api/auth/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    setSent(true);
    setLoading(false);
  };

  if (sent) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Check your email</h2>
        <p className="text-gray-600">If an account exists, a reset link was sent.</p>
        <Link to="/login" className="mt-4 block text-teal-600 font-semibold">Back to Login</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Forgot Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="email" placeholder="Your email" value={email}
            onChange={e => setEmail(e.target.value)} required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500" />
          <button type="submit" disabled={loading}
            className="w-full text-white py-3 rounded-lg font-semibold"
            style={{ background: 'linear-gradient(90deg, rgb(20,184,166), rgb(37,99,235))' }}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <Link to="/login" className="mt-4 block text-center text-teal-600">Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;